export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q04_b.6389da25.png";